import { EmailTemplate } from '../types';

export enum CACCorpIncorporationTaskGroup {
    COMPANY_FORMATION_DETAILS = "COMPANY_FORMATION_DETAILS",
    INCORPORATION_FILING = "INCORPORATION_FILING",
  }
  
  export enum CaCorpIncorporationTask {
    FILL_CORPORATION_DETAILS = "FILL_CORPORATION_DETAILS",
    REVIEW_CORPORATION_DETAILS = "REVIEW_CORPORATION_DETAILS",
    FILE_INCORPORATION = "FILE_INCORPORATION",
    UPLOAD_INCORPORATION_DOCUMENTS = "UPLOAD_INCORPORATION_DOCUMENTS",
    FILL_INCORPORATION_DETAILS = "FILL_INCORPORATION_DETAILS",
    SEND_EMAIL_UPDATE = "SEND_EMAIL_UPDATE",
  }
  
export const CA_CORP_TASK_GROUP_TO_EMAIL_MAP: Record<
  CACCorpIncorporationTaskGroup,
  EmailTemplate | null
> = {
  [CACCorpIncorporationTaskGroup.COMPANY_FORMATION_DETAILS]: null,
  [CACCorpIncorporationTaskGroup.INCORPORATION_FILING]: {
    body: `Hi,

Your documents are ready and are available to you in the documents tab of your dashboard.

Warm Regards

Commenda Team`,
    subject: 'Update on filing status with Commenda',
  },
};
